import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../app/hooks";
import { isAuth } from "../features/userLogin/userLoginSlice";

export const PrivateRoute = () => {
  const auth: boolean = useAppSelector(isAuth);
  const hasToken = (typeof window !== 'undefined' && !!localStorage.getItem('access_token')) || false;
  const isAuthenticated = auth || hasToken;
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};
